import User from "@/shared/models/User";
import ChangeTrackedEventValue from "@/shared/models/ChangeTrackedEventValue";

export enum ChangeTrackedEventAction {
    Updated,
    Added,
    Removed,
}

export default class ChangeTrackedEvent {
    id: string = "";
    timestampUTC: Date = new Date();
    user: User = new User();
    userEmail: string = "";
    property: string = "";
    oldValues: ChangeTrackedEventValue[] = [];
    newValue: ChangeTrackedEventValue[] = [];
    action: ChangeTrackedEventAction = ChangeTrackedEventAction.Updated;
}
